import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import styles from '../../components/Error/Error.module.scss';
import { CustomError, Settings } from '../../interfaces/Stylesheet';
import { getErrorTitle, SupportedErrorTypes } from '../../services/ErrorService';
import { useFormatting } from '../../services/hooks/useFormatting';
import usePageTitle from '../../services/hooks/usePageTitle';
import SquareAnimatedImage from '../SquareAnimatedImage/SquareAnimatedImage';

const getCustomError = (errorType: SupportedErrorTypes, settings?: Settings): CustomError | undefined => {
  if (errorType === SupportedErrorTypes.canceled) {
    return settings?.cancelError;
  }

  return undefined;
};

export const ErrorComponent: FC<{ errorType: SupportedErrorTypes; settings?: Settings }> = ({ errorType, settings }) => {
  const { t } = useTranslation();

  usePageTitle(t('pageTitle:error'));

  const showExpirationParagraph = errorType === SupportedErrorTypes.noSignatureFound;
  const customError = getCustomError(errorType, settings);
  const { formattedText } = useFormatting(customError?.description);

  return (
    <div className={styles.error}>
      <div className={styles.container}>
        {customError?.title
          ? <h2>{customError.title}</h2>
          : <SquareAnimatedImage ariaLabel="Error" image={{ type: 'svg', name: 'error' }} />}

        {customError
          ? <p dangerouslySetInnerHTML={{ __html: formattedText }} />
          : <h2>{getErrorTitle(t, errorType)}</h2>}

        {showExpirationParagraph && <p className={styles.expiredParagraph}>{t('errorMessages:signatureNotFoundParagraph')}</p>}
      </div>
    </div>
  );
};


export default Error;
